import { useEffect, useState } from 'react';
import { DropDownButton, DropdownItem } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';

interface PropertySelectorProps {
    handlePropertySelect: (property: Property) => void;
    handleAllPropertiesSelect: () => void;
    properties: Array<Property>;
    selectedProperty?: Property;
}

export interface Property {
    id: string;
    name: string;
    chainId: string;
}

export const PropertySelector = ({
    properties,
    selectedProperty,
    handlePropertySelect,
    handleAllPropertiesSelect,
}: PropertySelectorProps) => {
    const [allSelected, setAllSelected] = useState(false);

    /** This effect works only for the first time when the property is not selected */
    useEffect(() => {
        if (!selectedProperty && properties.length > 0) {
            if (properties && properties.length === 1) {
                setAllSelected(false);
                const defaultProperty = properties.at(0);
                if (defaultProperty) {
                    handlePropertySelect(defaultProperty);
                }
            } else {
                setAllSelected(true);
                handleAllPropertiesSelect();
            }
        }
    }, [properties, selectedProperty, handlePropertySelect, handleAllPropertiesSelect]);

    const handleClick = (property: Property) => {
        setAllSelected(false);
        handlePropertySelect(property);
    };

    const handleAllClick = () => {
        setAllSelected(true);
        handleAllPropertiesSelect();
    };

    return (
        <DropDownButton
            label={
                <>
                    {lt('Property')}
                    {UnicodeEntity.NoBreakSpace}
                    {UnicodeEntity.Colon}
                    {UnicodeEntity.Space}
                    {allSelected ? lt('All') : selectedProperty?.name}
                    {UnicodeEntity.Space}
                </>
            }
            variant="tertiary"
        >
            {properties.length > 1 && <DropdownItem label={lt('All')} value="all" onClick={() => handleAllClick()} />}
            {properties.map((property) => (
                <DropdownItem
                    key={property.id}
                    label={property.name}
                    value={property?.id}
                    onClick={(e) => {
                        handleClick(property);
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                />
            ))}
        </DropDownButton>
    );
};
